import type { ParsedUrlQuery } from 'querystring';

import { getQueryValue } from 'utils/cartParams';

interface Query {
  seller: string;
  source: string;
  accountId?: string;
  route?: string;
  id?: string;
  voucher?: string;
  test?: string;
  [key: string]: string | string[];
}

// Builds a new object with the `source` and `seller` defaults applied. It never
// touches the input, since `router.query` is owned by Next. Also used directly
// by class components that cannot call the `useRouterQuery` hook.
export function applyQueryDefaults(query: ParsedUrlQuery): Query {
  // A repeated param (`?source=a&source=b`) arrives as an array; take the first.
  const rawSource = getQueryValue(query.source);
  const source = rawSource ? rawSource.replace(/\//g, '').trim() : 'direto';
  const seller = getQueryValue(query.seller) || 'performance';

  return { ...query, source, seller } as Query;
}
